var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.auth.user.selectedAccess.roleLevel > 2)?_c('div',[_c('app-header',{attrs:{"title":_vm.$store.getters['translations/getLabel']('DISTRIBUTORS') ||
        'Distributors'}}),_c('b-container',[_c('DistributorList')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }